class HeaderBackgroundObserver {
  constructor() {
    this.header = document.querySelector('.header');
    this.isScrolled = false;
    this.scrollThreshold = 30; // 30px scroll threshold
    
    if (!this.header) return;
    
    this.init();
  }

  init() {
    // Set up the scroll listener
    this.setupScrollListener();
  }

  setupScrollListener() {
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          const scrollY = window.scrollY || window.pageYOffset;
          
          if (scrollY >= this.scrollThreshold && !this.isScrolled) {
            this.setSolidBackground();
          } else if (scrollY < this.scrollThreshold && this.isScrolled) {
            this.setTransparentBackground();
          }
          
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    
    // Store the handler so we can remove it later if needed
    this.scrollHandler = handleScroll;
  }

  setTransparentBackground() {
    if (this.isScrolled) {
      this.isScrolled = false;
      
      if (this.header) {
        this.header.classList.remove('header-scrolled');
      }
    }
  }

  setSolidBackground() {
    if (!this.isScrolled) {
      this.isScrolled = true;
      
      if (this.header) {
        this.header.classList.add('header-scrolled');
      }
    }
  }

  destroy() {
    if (this.scrollHandler) {
      window.removeEventListener('scroll', this.scrollHandler);
    }
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new HeaderBackgroundObserver();
});